export default __webpack_public_path__ + "static/media/liveFeedTag.a3a4a109.png";